import React from 'react';
import classnames from 'classnames';
import styles from './pagination.module.pcss';

interface PaginationProps {
  isDisabled: boolean;
  clickHandler: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children: React.ReactNode;
  page: number;
  rel: string;
  ref?: React.Ref<HTMLAnchorElement | HTMLButtonElement>;
}

function getPageURL(pageNumber: number): string {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('page', `${pageNumber}`);

  return `${window.location.pathname}?${searchParams}`;
}

function PaginationCTA({
  isDisabled = false,
  clickHandler,
  children,
  page,
  rel,
  ref
}: PaginationProps): React.ReactElement {
  return isDisabled ? (
    <button
      type="button"
      className={classnames(styles.pagination__cta, 'button--secondary-dark', 'button--large')}
      disabled={isDisabled}
      onClick={clickHandler}
      ref={ref as React.Ref<HTMLButtonElement>}
    >
      {children}
    </button>
  ) : (
    <a
      href={getPageURL(page)}
      className={classnames(styles.pagination__cta, 'button--secondary-dark', 'button--large')}
      onClick={clickHandler}
      rel={rel}
      ref={ref as React.Ref<HTMLAnchorElement>}
    >
      {children}
    </a>
  );
}

export default PaginationCTA;
